import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { DifferenceAbstraction } from 'routes/HowWeAreDifferent/components/Abstraction/DifferenceAbstraction'
import { DifferenceBlocks } from 'routes/HowWeAreDifferent/components/Blocks/DifferenceBlocks'
import classes from './DifferenceCustomDevelopment.module.scss'

export const DifferenceCustomDevelopment = () => {
  return (
    <Block as={'section'} divider={'full'} className={classes.section}>
      <hgroup>
        <Heading
          as={'h3'}
          size={'sm'}
          center
          balance
          className={classes.subject}
        >
          Universal Integration Layer vs Custom Development
        </Heading>
        <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
          Build your own integration logic and Ul <br />
          but do not reinvent the wheel
        </Heading>
      </hgroup>
      <DifferenceAbstraction />
      <DifferenceBlocks />
    </Block>
  )
}
